import React from "react";

const Contact = () => {
  return (
    <>
      <div className="contact">

        {/* <h1 className="H1">Contact</h1>           */}

        <main className="main2">

        {/* <h1 className="H1">Contact</h1>           */}

          <form className="form2">
            <div className="d2">
              <label className="label1">Name</label>
              <input className="i1" type="text" required placeholder="abc" />
            </div>

            <div className="d2">
              <label className="label1">Email</label>
              <input
                className="i1"
                type="text"
                required
                placeholder="Abc@xyz.com"
              />
            </div>

            <div className="d2">
              <label className="label1">Message</label>
              <input
                className="i1"
                type="text"
                required
                placeholder="Tell us about your problem"
              />
            </div>

            <button  type="submit">
              Send
            </button>
          </form>
        </main>
      </div>
    </>
  );
};

export default Contact;
